// extracted by mini-css-extract-plugin
export default {"brandPromo":"mG-z","carousel":"nG-z"};